import React from 'react';
import T from 'prop-types';
import LanguageNavigation from './language-navigation';
import CodeSnippet from './code-snippet';

export default function ContentSection({ title, languages, setState, index }) {
  const current = languages[index];
  const handleClick = e => {
    const { id } = e.target.dataset;
    const i = languages.findIndex(({ lang }) => lang === id);
    setState(i);
  };

  return (
    <section className="bg-cool-black text-white p-0 rounded-lg">
      <div className="flex items-center content-between border-b border-charcoal-grey px-12 sm:px-24 py-8 sm:py-16">
        <h4 className="tracking-widen-0.15 uppercase pr-8 sm:pr-24 text-overline1">{title}</h4>
        <LanguageNavigation id={title} handleClick={handleClick} collection={languages} current={current} />
      </div>
      <CodeSnippet current={current} />
    </section>
  );
}

ContentSection.propTypes = {
  title: T.string,
  languages: T.array,
  setState: T.func,
  index: T.number,
};
